import produce from "immer";

import {
    CandidateSearchActionTypes,
    names,
} from "./candidateSearchActionTypes";
import { SearchState } from "./candidateSearchState";

export const searchReducer = (
    state: SearchState,
    action: CandidateSearchActionTypes
) =>
    produce(state, draft => {
        draft.hasError = false;
        draft.error = undefined;
        switch (action.type) {
            case names.SEARCH: {
                draft.searching = true;
                draft.searchCriteria = action.payload.criteria;
                break;
            }

            case names.SEARCH_SUCCESS: {
                draft.searchResults = action.payload.results;
                draft.searching = false;
                break;
            }

            case names.SEARCH_ERROR: {
                draft.error = action.payload.apiError;
                draft.hasError = true;
                draft.searching = false;
                break;
            }

            case names.SORT: {
                let direction: SortDir = "asc";
                if (action.payload.field === draft.searchCriteria.sortField) {
                    direction =
                        state.searchCriteria.sortDir === "asc" ? "desc" : "asc";
                }
                draft.searchCriteria.sortField = action.payload.field;
                draft.searchCriteria.sortDir = direction;
                break;
            }

            case names.SORT_MOBILE: {
                draft.searchCriteria.sortField = action.payload.field;
                draft.searchCriteria.sortDir = action.payload.direction;
                break;
            }

            case names.NAVIGATE_NEXT: {
                const index = state.searchCriteria.pageIndex + 1;
                if (index <= action.payload.totalResults) {
                    draft.searchCriteria.pageIndex = index;
                }
                break;
            }

            case names.NAVIGATE_PREV: {
                const index = state.searchCriteria.pageIndex - 1;
                if (index >= 0) {
                    draft.searchCriteria.pageIndex = index;
                }
                break;
            }

            case names.SEARCH_BY_TEXT: {
                draft.searchCriteria.searchText = action.payload.searchText;

                // if we are changing the keyword search then reset the sort field and direction
                draft.searchCriteria.sortField =
                    state.searchCriteria.searchText !==
                    action.payload.searchText
                        ? "rank"
                        : state.searchCriteria.sortField;
                draft.searchCriteria.sortDir =
                    state.searchCriteria.searchText !==
                    action.payload.searchText
                        ? "desc"
                        : state.searchCriteria.sortDir;

                draft.searchCriteria.pageIndex = 1;
                break;
            }

            case names.FILTER_MULTIPLE: {
                const currentIds: any[] =
                    draft.searchCriteria[action.payload.id] || [];
                const currentNames: any[] =
                    draft.searchCriteria[action.payload.name] || [];
                if (action.payload.item && action.payload.item.value) {
                    const newItemId = parseFloat(action.payload.item.value);
                    if (currentIds.indexOf(newItemId) === -1) {
                        currentIds.push(newItemId);
                        currentNames.push(action.payload.item.label);
                    }
                } else {
                    if (action.payload.category) {
                        const index = currentNames.indexOf(
                            action.payload.category
                        );
                        currentIds.splice(index, 1);
                        currentNames.splice(index, 1);
                    }
                }

                draft.searchCriteria[action.payload.id] = currentIds;
                draft.searchCriteria[action.payload.name] = currentNames;
                draft.searchCriteria.pageIndex = 1;
                break;
            }

            case names.FILTER_SINGLE: {
                if (action.payload.item && action.payload.item.value) {
                    draft.searchCriteria[action.payload.id] = parseFloat(
                        action.payload.item.value
                    );
                    draft.searchCriteria[action.payload.name] =
                        action.payload.item.label;
                } else {
                    draft.searchCriteria[action.payload.id] = undefined;
                    draft.searchCriteria[action.payload.name] = undefined;
                }
                draft.searchCriteria.pageIndex = 1;
                break;
            }

            case names.FILTER_BY_SELECTED_CRITERIA: {
                draft.searchCriteria.searchText = action.payload.searchText;
                draft.searchCriteria.pageIndex = 1;
                break;
            }

            case names.MANAGE_CANDIDATE_FEEDBACK: {
                draft.searching = true;                
                break;
            }

            case names.MANAGE_CANDIDATE_FEEDBACK_FAILURE: {
                draft.error = action.payload.apiError;
                draft.hasError = true;
                draft.searching = false;
                break;
            }

            case names.MANAGE_CANDIDATE_FEEDBACK_SUCCESS: {
                const { comment, jobId, leadId, vote } = action.payload;

                const candidate = draft.searchResults.candidates.find(
                    c => c.jobId === jobId && c.leadId === leadId
                );
                if (!candidate) break;

                const previousVote = candidate.vote;
                candidate.vote = vote;

                if (previousVote !== candidate.vote) {
                    if (candidate.hasGivenFeedback) {
                        candidate.negativeVoteCount =
                            candidate.negativeVoteCount + (vote ? -1 : 1);
                        candidate.positiveVoteCount =
                            candidate.positiveVoteCount + (vote ? 1 : -1);
                    } else {
                        vote
                            ? (candidate.positiveVoteCount =
                                  candidate.positiveVoteCount + 1)
                            : (candidate.negativeVoteCount =
                                  candidate.negativeVoteCount + 1);
                    }
                }

                candidate.hasGivenFeedback = true;
                candidate.canViewFeedback = true;
                candidate.comment = comment;
                draft.searching = false;
                break;
            }

            case names.CLEAR_ERRORS: {
                draft.error = undefined;
                draft.hasError = false;
                break;
            }
        }
    });
